import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    fullscreenButton: {
        width: 40,
        height: 40,
    },
});

export default styles;
